export const POST_LOGOUT_PATH = '/';
export const SIGNED_OUT_LOGIN_PATH = '/?login=1';

/** Public creation CTAs authenticate before opening their selected workflow. */
export function buildCreationLoginHref(redirectTo: string, locale: string): string {
  const params = new URLSearchParams({ redirect: redirectTo, login: '1', lang: locale });
  return `/login?${params.toString()}`;
}

export function buildSignedOutLoginPath(redirectTo?: string): string {
  return redirectTo
    ? `${SIGNED_OUT_LOGIN_PATH}&redirect=${encodeURIComponent(redirectTo)}`
    : SIGNED_OUT_LOGIN_PATH;
}
